import React from 'react'
import { EcosistemaMobilityImage } from '@next-nx/shared-ui/organisms'
import { EcosistemaImageSettings } from './EcosistemaImageSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { useEditor } from '@craftjs/core'

export const defaultProps = {
  testoRental: 'testoRental',
  testoService: 'testoService',
  testoGlass: 'testoGlass',
  testoAssistance: 'testoAssistance',
  testoTech: 'testoTech',
}

export const EcosistemaImage = withBlock((props) => {
  const blockProps = {
    ...defaultProps,
    ...props.block,
  }

  const { testoRental, testoService, testoGlass, testoAssistance, testoTech } = blockProps

  const { children } = props

  const { enabled } = useEditor((state) => ({
    enabled: state.options.enabled,
  }))

  return (
    <div ref={(ref) => props.retRef(ref)} className={' ' + props.className}>
      <EcosistemaMobilityImage
        testoRental={testoRental}
        testoService={testoService}
        testoGlass={testoGlass}
        testoAssistance={testoAssistance}
        testoTech={testoTech}
      />
    </div>
  )
}, defaultProps)

EcosistemaImage.craft = withCraft({
  name: 'EcosistemaImage',
  defaultProps: defaultProps,
  settings: EcosistemaImageSettings,
})
